<router-outlet></router-outlet>

<p-confirmdialog key="updateDialog" position="top" />

<p-confirmdialog key="notificationPermissionDialog" position="top" />

<p-toast position="bottom-center" />

<p-toast position="top-right" key="followups">
    <ng-template let-message pTemplate="message">
        <div class="w-full" style="cursor: pointer;">
            <div class="flex items-start flex-col mb-2">
                <span class="font-semibold text-lg text-blue-500">{{ message.summary }}</span>
                <span class="text-sm text-gray-500">
                    für {{ message.data?.followUpDate | date: 'fullDate' : 'DE-de' }} um {{ message.data?.followUpDate | date: 'HH:mm' : 'DE-de' }} Uhr
                </span>
            </div>
            <div class="text-gray-600">
                <h1 class="mb-1"><b>{{ message.data?.title }}</b></h1>
                <div class="text-sm text-gray-500 flex items-center">
                    <i class="text-xs mr-1" [class]="getActivityStyle(message.data?.category).icon"></i> 
                    {{ message.data?.category }} |
                    {{ message.data?.expand?.contactId.salutation | salutation }} 
                    {{ message.data?.expand?.contactId.firstnName }} 
                    {{ message.data?.expand?.contactId.lastName }}
                    | {{ message.data?.expand?.leadId.name }}
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>